<template>
  <div class="row">
    <div class="col-lg-3 col-sm-6 col-12" @click="goToLowStock" style="cursor: pointer;" title="View Details">
      <div class="dash-widget">
        <div class="dash-widgetimg">
          <span><img src="../../../assets/img/icons/dash3.svg" alt="img" /></span>
        </div>
        <div class="dash-widgetcontent">
          <h5>
            <vue3-autocounter
              class="counter"
              ref="counter"
              :startAmount="0"
              :delay="3"
              :endAmount="data.lowstock"
              :duration="2"
              :autoinit="true"
            />
          </h5>
          <h6>Low Stock</h6>
        </div>
      </div>
    </div>
    <div class="col-lg-3 col-sm-6 col-12" @click="goToNoStock" style="cursor: pointer;" title="View Details">
      <div class="dash-widget dash1">
        <div class="dash-widgetimg">
          <span><img src="../../../assets/img/icons/dash4.svg" alt="img" /></span>
        </div>
        <div class="dash-widgetcontent">
          <h5>
            <vue3-autocounter
              class="counter"
              ref="counter"
              :startAmount="0"
              :delay="3"
              :endAmount="data.nostock"
              :duration="2"
              :autoinit="true"
            />
          </h5>
          <h6>Out of Stock</h6>
        </div>
      </div>
    </div>
    <div class="col-lg-3 col-sm-6 col-12" @click="goToAllStock" style="cursor: pointer;" title="View Details">
      <div class="dash-widget dash2">
        <div class="dash-widgetimg">
          <span><img src="../../../assets/img/icons/dash1.svg" alt="img" /></span>
        </div>
        <div class="dash-widgetcontent">
          <h5>
            <vue3-autocounter
              class="counter"
              ref="counter"
              :startAmount="0"
              :delay="3"
              :endAmount="data.totalitems"
              :duration="3"
              :autoinit="true"
            />
          </h5>
          <h6>Total Items</h6>
        </div>
      </div>
    </div>
    <div class="col-lg-3 col-sm-6 col-12">
      <div class="dash-widget dash">
        <div class="dash-widgetimg">
          <span><img src="../../../assets/img/icons/dash2.svg" alt="img" /></span>
        </div>
        <div class="dash-widgetcontent">
          <h5>
            ₹<vue3-autocounter
              class="counter"
              ref="counter"
              :startAmount="0"
              :delay="3"
              :endAmount="data.itemsvalue"
              :duration="3"
              :autoinit="true"
            />
          </h5>
          <h6>Stock Value</h6>
        </div>
      </div>
    </div>
    <!-- Chart -->
    <div class="col-md-6">
        <div class="card">
          <div class="card-header">
          <div class="dashboard-card-head">
            <div class="card-title mb-0">Issued to {{ issueViewLabel }} (Current Month)</div>
            <div class="dashboard-filter-wrap" role="group" aria-label="Issue view">
              <button
                v-for="option in issueViewOptions"
                :key="option.value"
                type="button"
                class="dashboard-toggle-btn"
                :class="{ active: issueViewMode === option.value }"
                :aria-pressed="issueViewMode === option.value"
                @click="setIssueViewMode(option.value)"
              >
                {{ option.label }}
              </button>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="chartjs-wrapper-demo">
            <apexchart
              type="donut"
              height="220"
              :options="donutchart"
              :series="deptseries"
            ></apexchart>
          </div>
        </div>
      </div>
    </div>
    <!-- /Chart -->

    <!-- Chart -->
    <div class="col-md-6">
      <div class="card">
        <div class="card-header">
          <div class="card-title">Most Purchased (Current Month)</div>
        </div>
        <div class="card-body">
          <div class="chartjs-wrapper-demo">
            <apexchart
              type="donut"
              height="220"
              :options="piechart"
              :series="categoryseries"
            ></apexchart>
          </div>
        </div>
      </div>
    </div>
    <!-- /Chart -->
  </div>
  <!-- Button trigger modal -->
  <div class="row">
    <div class="col-lg-7 col-sm-12 col-12 d-flex">
      <div class="card flex-fill">
        <div class="card-header pb-0 d-flex justify-content-between align-items-center">
          <h5 class="card-title mb-0">Purchase & Issued</h5>
          <div class="graph-sets">
            <ul>
              <li class="me-4">
                <span>Purchases</span>
              </li>
              <li class="ms-2">
                <span>Issued</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="card-body">
          <apexchart
            type="bar"
            ref="chart"
            height="300"
            :options="basicAreaChart"
            :series="barchartseries"
          ></apexchart>
        </div>
      </div>
    </div>
    <div class="col-lg-5 col-sm-12 col-12 d-flex">
      <div class="card flex-fill">
        <div class="card-header pb-0 d-flex justify-content-between align-items-center">
          <h4 class="card-title mb-0">Most Issued</h4>
          <div class="dropdown">
            <a
              href="javascript:void(0);"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              class="dropset"
            >
              <i class="fa fa-ellipsis-v"></i>
            </a>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <li>
                <router-link to="saleslist" class="dropdown-item"
                  >Issue List</router-link
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="card-body">
          <div class="table-responsive dataview datatableIndex">
            <a-table :columns="mostcomcolumns" :data-source="data.mostconsumed" @change="onChange">
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'itemid'">
                  <div class="productimgname">
                    <router-link to="productlist">{{ record.itemname }}</router-link>
                  </div>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-6 col-sm-12 col-12 d-flex">
      <div class="card mb-0">
        <div class="card-body justify-content-between">
          <h4 class="card-title">Low on stock</h4>
          <div class="table-responsive dataview datatableIndex">
            <a-table :columns="columns" :data-source="data.lowstocklist" @change="onChange">
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'itemid'">
                  <div class="productimgname">
                    
                    <router-link to="productlist">{{ record.itemname }}</router-link>
                  </div>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-sm-12 col-12 d-flex">
      <div class="card mb-0">
        <div class="card-body justify-content-between">
          <h4 class="card-title">Out of stock</h4>
          <div class="table-responsive dataview datatableIndex">
            <a-table :columns="columns" :data-source="data.nostocklist" @change="onChange">
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'itemid'">
                  <div class="productimgname">
                    
                    <router-link to="productlist">{{ record.itemname }}</router-link>
                  </div>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { ref } from "vue";
import createpurchasereturnVue from '../return/createpurchasereturn.vue';
const currentDate = ref(new Date());
const columns = [
  {
    title: "Item Name",
    dataIndex: "itemname",
    key: "itemid",
    sorter: {
      compare: (a, b) => {
        a = a.itemname.toLowerCase();
        b = b.itemname.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Category",
    dataIndex: "category",
    sorter: {
      compare: (a, b) => {
        a = a.category.toLowerCase();
        b = b.category.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Available",
    dataIndex: "available",
    key: "available",
    sorter: {
      compare: (a, b) => {
        a = a.available;
        b = b.available;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
];
const mostcomcolumns = [
  {
    title: "Item Name",
    dataIndex: "itemname",
    key: "itemid",
    sorter: {
      compare: (a, b) => {
        a = a.itemname.toLowerCase();
        b = b.itemname.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Category",
    dataIndex: "category",
    sorter: {
      compare: (a, b) => {
        a = a.category.toLowerCase();
        b = b.category.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Branch",
    dataIndex: "branch",
    sorter: {
      compare: (a, b) => {
        a = (a.branch || '').toLowerCase();
        b = (b.branch || '').toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Dealer",
    dataIndex: "dealer",
    sorter: {
      compare: (a, b) => {
        a = (a.dealer || '').toLowerCase();
        b = (b.dealer || '').toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Count",
    dataIndex: "total",
    sorter: {
      compare: (a, b) => {
        a = a.total;
        b = b.total;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
];
const deptChart = {
  chart: {
    height: 220,
    stacked: true,
    toolbar: {
      show: false,
    },
    type: 'donut',
  },
  dataLabels: {
    enabled: false
  },
  responsive: [{
    breakpoint: 480,
    options: {
      chart: {
        width: 200
      },
      legend: {
        show: false
      }
    }
  }],
  legend: {
    position: 'right',
  },
};

const catChart = {
  chart: {
    height: 220,
    stacked: true,
    toolbar: {
      show: false,
    },
    type: 'donut',
  },
  dataLabels: {
    enabled: false
  },
  responsive: [{
    breakpoint: 480,
    options: {
      chart: {
        width: 200
      },
      legend: {
        show: false
      }
    }
  }],
  legend: {
    position: 'right',
  },
};

const basicAreaChart = {
    chart: {
      id: "vuechart-puchase-issued",
      type: 'bar',
      height: 300,
      stacked: true,
        toolbar: {
          show: false,
        },
        zoom: {
                enabled: true
        }
    },
    colors: ['#28C76F', '#EA5455'],
    dataLabels: {
        enabled: false
    },
    responsive: [{
      breakpoint: 280,
      options: {
          legend: {
          position: '',
          offsetY: 40,
          }
      }
    }],
    plotOptions: {
      bar: {
          horizontal: false,
          columnWidth: '20%',
          endingShape: 'rounded'
      },
    },
    xaxis: {
      categories: [],
    },
    fill: {
      opacity: 1
    },
  
};
const data = {
    "lowstock": 0,
    "nostock": 0,
    "nostocklist": [],
    "lowstocklist": [],
    "deptconsumption": [],
    "dealerconsumption": [],
    "mostconsumed": [],
    "mostpurchased": [],
    "purchase_issued": {}
};
export default {
  data() {
    return {
      basicAreaChart: basicAreaChart,
      donutchart: deptChart,
      piechart: catChart,
      deptseries: [],
      categoryseries: [],
      barchartseries: [], 
      issueViewMode: 'branch',
      issueViewOptions: [
        { label: 'Branch', value: 'branch' },
        { label: 'Dealer', value: 'dealer' },
      ],
      data,
      columns,
      mostcomcolumns,
      startdate: currentDate,
    };
  },
  computed: {
    issueViewLabel() {
      return this.issueViewMode === 'dealer' ? 'Dealer' : 'Branch';
    },
  },
  methods: {
    goToLowStock() {
      this.$router.push({ path: '/productlist', query: { category: 'low_stock' } });
    },
    goToNoStock() {
      this.$router.push({ path: '/productlist', query: { category: 'out_of_stock' } });
    },
    goToAllStock() {
      this.$router.push({ path: '/productlist', query: { category: 'all' } });
    },
    setIssueViewMode(mode) {
      this.issueViewMode = mode;
      this.refreshIssueChart();
    },
    refreshIssueChart() {
      const source = this.issueViewMode === 'dealer'
        ? (this.data.dealerconsumption || [])
        : (this.data.deptconsumption || []);

      const labels = [];
      const chartdata = [];

      source.forEach((row) => {
        labels.push(this.issueViewMode === 'dealer' ? row.dealer : row.branch);
        chartdata.push(row.total);
      });

      this.deptseries = chartdata;
      this.donutchart = {
        ...this.donutchart,
        labels,
      };
    },
    async getDashboard() {
      axios
      .get('/v1/items/dashboard')
      .then(response => {
        this.data = response.data
        this.refreshIssueChart();
        var catlabels = [];
        var catchartdata = [];
        this.data.mostpurchased.forEach(row => {
          catlabels.push(row.itemname);
          catchartdata.push(row.count);
        });
        this.categoryseries = catchartdata; 
        this.piechart = {
          ...this.piechart,
          labels: catlabels
        }

        const purchase_issue = this.data.purchase_issued
        this.barchartseries = [{name: 'Purchases', data: purchase_issue.purchases},
                {name: 'Issued', data: purchase_issue.dispatches}]
        this.basicAreaChart = {
          ...this.basicAreaChart,
          xaxis: {
            categories: purchase_issue.month
          }
        };
        
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      });
    },
  },
  beforeMount() {
    this.getDashboard();
  },
};
</script>
<style scoped>
.dashboard-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.dashboard-filter-wrap {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  border-radius: 8px;
  background-color: #f8f9fc;
  border: 1px solid #d8dbe7;
}

.dashboard-toggle-btn {
  min-width: 74px;
  height: 30px;
  padding: 0 14px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #5b667a;
  font-size: 13px;
  font-weight: 600;
  line-height: 30px;
  transition: background-color 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;
}

.dashboard-toggle-btn.active {
  background-color: #ffffff;
  color: #1b2850;
  box-shadow: 0 2px 8px rgba(27, 40, 80, 0.12);
}

.dashboard-toggle-btn:focus-visible {
  outline: 2px solid #ff9f43;
  outline-offset: 2px;
}

@media (max-width: 575.98px) {
  .dashboard-card-head {
    align-items: flex-start;
  }

  .dashboard-filter-wrap {
    width: 100%;
  }

  .dashboard-toggle-btn {
    flex: 1;
  }
}

.dash-widget.dash2:hover {
  background-color: rgba(245, 245, 245, 0.916); 
}
.dash-widget.dash1:hover {
  background-color: rgba(245, 245, 245, 0.916); 
}
.dash-widget:hover {
  background-color: rgba(245, 245, 245, 0.916); 
}
</style>
